"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = exports.Timeline = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  margin: 1em 0;\n  align-items: center;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 0 1em;\n  padding: 0.25em 1em;\n  background: ", ";\n  color: ", ";\n  border-radius: 1em;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-left: 2.5em;\n\n  :before {\n    background-color: ", ";\n    content: '';\n    margin-left: 1px;\n    position: absolute;\n    top: 0;\n    left: -2em;\n    width: 2px;\n    height: 100%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border: ", ";\n  padding: ", ";\n  background: ", ";\n  border-radius: 10px;\n  display: block;\n  width: 1em;\n  height: 1em;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: 95%;\n  list-style: none;\n  padding: 0px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var e = _react["default"].createElement;

var StyledContainer = _styledComponents["default"].div(_templateObject());

var StyledList = _styledComponents["default"].ul(_templateObject2());

var StyledItem = _styledComponents["default"].li(_templateObject3());

var StyledIcon = _styledComponents["default"].div(_templateObject4(), function (props) {
  if (props.lineColor === null) {
    return 'none';
  }

  return "2px solid ".concat(props.lineColor);
}, function (props) {
  if (props.lineColor === null) {
    return '2px';
  }

  return '0';
}, function (props) {
  return props.iconFill;
});

var Interval = function Interval(_ref) {
  var interval = _ref.interval,
      separator = _ref.separator;

  if (typeof interval === 'string') {
    return interval;
  }

  if (interval.start && interval.end) {
    return _react["default"].createElement(_react["default"].Fragment, null, interval.start, separator, interval.end);
  }

  if (!interval.start && interval.end) {
    return _react["default"].createElement(_react["default"].Fragment, null, "now", separator, interval.end);
  }

  if (interval.start && !interval.end) {
    return _react["default"].createElement(_react["default"].Fragment, null, interval.start, separator, "now");
  }

  return '';
};

var StyledContent = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.lineColor;
});

var StyledInterval = _styledComponents["default"].p(_templateObject6(), function (props) {
  return props.background;
}, function (props) {
  return props.color;
});

var StyledTitle = (0, _styledComponents["default"])(function (_ref2) {
  var tag = _ref2.tag,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["tag", "children"]);

  return e(tag, props, children);
})(_templateObject7());
StyledTitle.defaultProps = {
  tag: 'h3'
};

var StyledDescription = _styledComponents["default"].div(_templateObject8());

var StyledSubtitle = (0, _styledComponents["default"])(function (_ref3) {
  var tag = _ref3.tag,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["tag", "children"]);

  return e(tag, props, children);
})(_templateObject9());
StyledSubtitle.defaultProps = {
  tag: 'h4'
};

var StyledIntervalContainer = _styledComponents["default"].div(_templateObject10());

var Timeline = function Timeline(_ref4) {
  var lineColor = _ref4.lineColor,
      intervalSeparator = _ref4.intervalSeparator,
      children = _ref4.children;

  var childrenWithProps = _react["default"].Children.map(children, function (child) {
    return _react["default"].cloneElement(child, {
      lineColor: child.props.lineColor || lineColor,
      intervalSeparator: child.props.intervalSeparator || intervalSeparator
    });
  });

  return _react["default"].createElement(StyledContainer, null, _react["default"].createElement(StyledList, null, childrenWithProps));
};

exports.Timeline = Timeline;
Timeline.propTypes = {
  lineColor: _propTypes["default"].string.isRequired,
  intervalSeparator: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  children: _propTypes["default"].node
};
Timeline.defaultProps = {
  intervalSeparator: _react["default"].createElement(_react["default"].Fragment, null, "\xA0\u2014 "),
  children: null
};

var Event = function Event(_ref5) {
  var title = _ref5.title,
      subtitle = _ref5.subtitle,
      interval = _ref5.interval,
      children = _ref5.children,
      lineColor = _ref5.lineColor,
      titleTag = _ref5.titleTag,
      subtitleTag = _ref5.subtitleTag,
      intervalColor = _ref5.intervalColor,
      intervalSeparator = _ref5.intervalSeparator,
      intervalBackground = _ref5.intervalBackground,
      iconFill = _ref5.iconFill,
      iconOutline = _ref5.iconOutline;
  return _react["default"].createElement(StyledItem, null, _react["default"].createElement(StyledIntervalContainer, null, _react["default"].createElement(StyledIcon, {
    lineColor: iconOutline === null ? null : iconOutline || lineColor,
    iconFill: iconFill
  }), _react["default"].createElement(StyledInterval, {
    color: intervalColor,
    background: intervalBackground
  }, _react["default"].createElement(Interval, {
    interval: interval,
    separator: intervalSeparator
  }))), _react["default"].createElement(StyledContent, {
    lineColor: lineColor
  }, _react["default"].createElement(StyledTitle, {
    tag: titleTag
  }, title), subtitle && _react["default"].createElement(StyledSubtitle, {
    tag: subtitleTag
  }, subtitle), _react["default"].createElement(StyledDescription, null, children)));
};

exports.Event = Event;
Event.propTypes = {
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  interval: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  intervalSeparator: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  children: _propTypes["default"].node,
  lineColor: _propTypes["default"].string,
  titleTag: _propTypes["default"].string,
  subtitleTag: _propTypes["default"].string,
  intervalColor: _propTypes["default"].string,
  intervalBackground: _propTypes["default"].string,
  iconFill: _propTypes["default"].string,
  iconOutline: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].oneOf([null, undefined])])
};
Event.defaultProps = {
  subtitle: '',
  interval: 'Now',
  children: null,
  titleTag: 'h3',
  subtitleTag: 'h4',
  intervalBackground: '#cccccc',
  intervalColor: '#000000',
  iconFill: 'transparent',
  iconOutline: undefined,
  lineColor: '#000000',
  intervalSeparator: _react["default"].createElement(_react["default"].Fragment, null, "\xA0\u2014 ")
};